import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { VALUE_SCORE } from '../../constant'
import { TEXT_BY_TYPE_SCORE } from '../../portfolioDistribution'
import { PopupScoreTrend } from './PopupScoreTrend'

export const PopupEditScoreDynamic = ({ type }) => {
  const [isShow, setShow] = useState(false)

  const onClick = () => {
    setShow(true)
  }

  return (
    <>
      <div className="dFlex fstItalic">
        <Translate
          value={`portfolioScore.${
            type === VALUE_SCORE.CREDIT_SCORE
              ? 'settingRisk'
              : 'settingPerformance'
          }`}
        />
        &nbsp;
        <Element
          onClick={onClick}
          style={{ color: '#2C73E8' }}
          className="cursorPointer"
        >
          <Translate value="portfolioScore.here" />
        </Element>
      </div>
      {isShow && (
        <PopupScoreTrend
          isShow={isShow}
          onClose={() => setShow(false)}
          title={TEXT_BY_TYPE_SCORE[type].title}
          isDynamic
          typeValue={type}
        />
      )}
    </>
  )
}
